import { Dialog } from '@progress/kendo-react-dialogs';
import { DisputeCard } from 'components';
import { DisputeSummary } from 'types';
import styles from './RelatedDisputes.module.scss';

export type RelatedDisputesProps = {
    /*
     * List of related disputes
     */
    disputes: DisputeSummary[],
    /**
     * Indicates whether the dialog is visible
     */
    show?: boolean,
    /**
     * The function to call when the dialog is closed
     */
    onClose: () => void
};

export const RelatedDisputes = ({ disputes, show, onClose }: RelatedDisputesProps) => {
    const count = disputes.length;
    const height = count > 3 ? '82%' : (count === 3 ? '64%' : undefined);
    return show ? (
        <Dialog className={styles.dialog} height={height} title="Related Disputes" onClose={onClose} closeIcon={true}>
            <div className={styles.container1}>
                {disputes.map((summary) => <DisputeCard disputeSummary={summary} />)}
            </div>
        </Dialog>
    ) : null;
};